<div class="form-group row" *ngIf="control.visible" [formGroup]="formGroup">
  <div class="col-md-12">
    <hb-df-control-label [control]="control" (onOverrideValue)="overrideValue()"></hb-df-control-label>
  </div>
  <div class="col-md-12" style="display: flex">
    <select
      class="form-control hb-dropdown hb-double-dropdown ac-box mr-1"
      #leftDropdown
      [id]="control.key"
      [value]="control._leftValue"
      [formControlName]="control.key"
      [attr.placeholder]="control.placeholder || control.label"
      [attr.disable]="control.disabled"
      (change)="control.leftOnChange(leftDropdown.value)"
    >
      <option *ngFor="let opt of control?.options" [value]="opt.key">{{ opt.value }}</option>
    </select>
    <select
      class="form-control hb-dropdown hb-double-dropdown ac-mainbox ml-1"
      #rightDropdown
      [id]="control.rightKey"
      [value]="control._rightValue"
      [formControlName]="control.rightKey"
      [attr.placeholder]="control.rightPlaceholder"
      [attr.disable]="control.disabled"
      (change)="control.rightOnChange(rightDropdown.value)"
    >
      <option *ngFor="let opt of control.rightDropdownOptions" [value]="opt.key">{{ opt.value }}</option>
    </select>
  </div>
</div>
